import { render, staticRenderFns } from "./salesStatistics.vue?vue&type=template&id=6493564a&scoped=true&"
import script from "./salesStatistics.vue?vue&type=script&lang=js&"
export * from "./salesStatistics.vue?vue&type=script&lang=js&"
import style0 from "./salesStatistics.vue?vue&type=style&index=0&id=6493564a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6493564a",
  null
  
)

export default component.exports